import React, { useState } from "react";
import { Input } from "./input";
import { Eye, EyeOff } from "lucide-react";

interface PasswordInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
}

const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ label, ...props }, ref) => {
    const [show, setShow] = useState(false);

    return (
      <div className="relative">
        {label && (
          <label className="text-sauna-navy font-semibold mb-1 block" htmlFor={props.id}>
            {label}
          </label>
        )}
        <Input
          {...props}
          ref={ref}
          type={show ? "text" : "password"}
          className="pr-10"
        />
        <button
          type="button"
          tabIndex={-1}
          className="absolute right-2 top-1/2 -translate-y-1/2 text-sauna-navy/60 hover:text-sauna-orange"
          onClick={() => setShow((s) => !s)}
          aria-label={show ? "Hide password" : "Show password"}
        >
          {show ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
        </button>
      </div>
    );
  }
);

PasswordInput.displayName = "PasswordInput";
export default PasswordInput; 